import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    comparisonTeaserData,
    comparisonTeaserData2,
    TeaserComparison,
} from "../teaser/comparison/teaser-comparison.templates";
import { pageStoryDecorator } from "../../../shared/page";

export default {
    title: "Website/Partial Templates/Series-Comparison",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    decorators: [pageStoryDecorator],
    args: {
        sliderAlign: "right",
        background: "background1",
        secondButton: false,
    },
    argTypes: {
        sliderAlign: {
            control: {
                type: "radio",
            },
            options: ["left", "right"],
        },
        background: {
            control: {
                type: "select",
            },
            options: [
                "background1",
                "background2",
                "background3",
                "background4",
                "background5",
                "background6",
                "background7",
                "background8",
                "background9",
                "background-sf-2",
            ],
        },
        secondButton: {
            control: {
                type: "boolean",
            },
        },
        withList: {
            control: {
                type: "boolean",
            },
        },
    },
};

interface SeriesComparisonProps {
    sliderAlign: "left" | "right";
    background: string;
    secondButton: boolean;
    withList: boolean;
}

const template = ({
    sliderAlign,
    background,
    secondButton,
    withList,
}: SeriesComparisonProps) => {
    return html`
        <div class="ux-t-container-full">
            <div class="ux-row">
                <div class="ux-col-12">
                    <ux-iws-teaser-comparison
                        background="${background}"
                        slider-align="${sliderAlign}"
                    >
                        <div slot="text">
                            <h3
                                class="ux-iws-teaser-comparison__text-block__title"
                            >
                                Test Headline
                            </h3>
                            <p>
                                Lorem ipsum dolor sit amet, consetetur
                                sadipscing elitr, sed diam nonumy eirmod tempor
                                invidunt ut labore et dolore magna aliquyam
                                erat, sed diam voluptua. At vero eos et accusam
                                et justo duo dolores et ea rebum.
                            </p>
                            ${withList
                                ? html` <ul class="list-styled">
                                      <li>
                                          <strong>Geschwindigkeit</strong>:
                                          Laserschweißen ist für gewöhnlich
                                          schneller als MIG-/MAG- oder
                                          WIG-Schweißen.
                                      </li>
                                      <li>
                                          <strong
                                              >Kein Zusatzmaterial nötig</strong
                                          >: Beim MIG-/MAG-Schweißen ist immer
                                          Schweißdraht als Zusatz nötig. Auch
                                          bei WIG kommt häufig ein Schweißzusatz
                                          zum Einsatz. Beim Laserschweißen ist
                                          das in den meisten Fällen nicht
                                          notwendig, was zu saubereren
                                          Schweißnähten führt.
                                      </li>
                                  </ul>`
                                : ""}
                            <div>
                                <a href="#" class="ux-button ux-button--primary"
                                    >More Info</a
                                >
                                ${secondButton
                                    ? html`<a href="#" class="ux-button"
                                          >Secondary</a
                                      >`
                                    : ""}
                            </div>
                        </div>
                        <ux-slider-slide>
                            ${TeaserComparison(comparisonTeaserData, "")}
                        </ux-slider-slide>
                        <ux-slider-slide>
                            ${TeaserComparison(comparisonTeaserData2, "")}
                        </ux-slider-slide>
                        <ux-slider-slide>
                            ${TeaserComparison(comparisonTeaserData, "")}
                        </ux-slider-slide>
                        <ux-slider-slide>
                            ${TeaserComparison(comparisonTeaserData2, "")}
                        </ux-slider-slide>
                    </ux-iws-teaser-comparison>
                </div>
            </div>
        </div>
    `;
};
export const SeriesComparisonSlider = template.bind({});
SeriesComparisonSlider.args = {
    sliderAlign: "right",
    background: "background1",
    secondButton: false,
};

export const SeriesComparisonSliderLeft = template.bind({});
SeriesComparisonSliderLeft.args = {
    sliderAlign: "left",
    background: "background1",
    secondButton: false,
};

export const SeriesComparisonSliderDark = template.bind({});
SeriesComparisonSliderDark.args = {
    sliderAlign: "right",
    background: "background3",
    secondButton: true,
};
